import _State from '@states/_State.js';

const UserState = _State('user', 'setUser', null);
// add new methods to state if needed

export default UserState;
